function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('../Scripts/js-external-libs/', true, /\.js$/));

import 'script-loader!../Scripts/script-loader/base64.min';
import 'script-loader!../Scripts/script-loader/store.legacy.min';
import 'script-loader!../Scripts/script-loader/html2canvas';
